import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_purchases_by_supplier,
    getReportLabel: () => t`Purchase Summary by Supplier`,
    getColumns: () => [],
};
